import i18n from 'i18next'

export const RegExpTime = {
  get12Hours: () => {
    const am = i18n.t('calendar.time.AM')
    const pm = i18n.t('calendar.time.PM')
    return new RegExp(`^(\\d{1,2}:\\d{2}\\s?(${am}|${pm})|(${am}|${pm})\\s?\\d{1,2}:\\d{2})$`)
  },
  get24Hours: () => {
    return /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
  },
}

const rangeOfDigit = (v: string): { start: number; end: number } => {
  let start = -1
  let end = -1
  for (let i = 0; i < v.length; i++) {
    if (v[i] >= '0' && v[i] <= '9') {
      if (start === -1) {
        start = i
      }
      end = i
    }
  }
  return { start, end }
}

export const get12FormatTime = (v: string): string => {
  const { start, end } = rangeOfDigit(v)
  return v.substring(start, end + 1)
}

export const TimeParserFor12Hour = {
  getHour: (v: string): number => {
    if (!v) return NaN

    const time = get12FormatTime(v)
    const [hourStr] = time.split(':')
    const hour = parseInt(hourStr, 10)

    if (v.includes(i18n.t('calendar.time.PM'))) {
      return hour === 12 ? 12 : hour + 12
    }
    if (hour === 12) {
      return 0
    }
    return hour
  },
  getMinute: (v: string): string => {
    if (!v) return 'NaN'
    const time = get12FormatTime(v)
    const [_, minuteStr] = time.split(':')
    const minute = parseInt(minuteStr, 10)
    return minute.toString().padStart(2, '0')
  },
  getTime: (v: string): string => {
    if (!v) return 'NaN'
    const hour = TimeParserFor12Hour.getHour(v)
    const minute = TimeParserFor12Hour.getMinute(v)
    return `${hour === 12 ? '12' : hour}:${minute}`
  },
}
